import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import lodashGet from 'lodash/get';
import { useMemo, useCallback } from 'react';
import { DropdownMenu } from 'react-science/ui';
import { buildID } from '../../../data/utilities/Concatenation';
import { useAssignment, } from '../../assignment/AssignmentsContext';
import { useHighlight } from '../../highlight';
import ActionsColumn from './TableColumns/ActionsColumn';
import SignalAssignmentsColumns from './TableColumns/SignalAssignmentsColumns';
import SignalDeltaColumn from './TableColumns/SignalDeltaColumn';
import ZoneAssignmentsColumns from './TableColumns/ZoneAssignmentsColumns';
const HighlightedRowStyle = { backgroundColor: '#ff6f0057' };
const ConstantlyHighlightedRowStyle = { backgroundColor: '#f5f5dc' };
function ZonesTableRow({ rowData, onUnlink, contextMenu = [], onContextMenuSelect, rowIndex, format, }) {
    const assignmentZone = useAssignment(rowData.id);
    const highlightZone = useHighlight([assignmentZone.id]);
    const highlightZoneX = useHighlight([buildID(assignmentZone.id, 'X')].concat(assignmentZone.assigned?.x || []));
    const highlightZoneY = useHighlight([buildID(assignmentZone.id, 'Y')].concat(assignmentZone.assigned?.y || []));
    const assignmentSignal = useAssignment(rowData.tableMetaInfo.id);
    const highlightSignalX = useHighlight([buildID(assignmentSignal.id, 'X')].concat(assignmentSignal.assigned?.x || [], buildID(assignmentSignal.id, 'Crosshair')));
    const highlightSignalY = useHighlight([buildID(assignmentSignal.id, 'Y')].concat(assignmentSignal.assigned?.y || [], buildID(assignmentSignal.id, 'Crosshair')));
    const rowSpanTags = useMemo(() => {
        return {
            rowSpan: rowData.tableMetaInfo.rowSpan,
            style: lodashGet(rowData, 'tableMetaInfo.hide', false)
                ? { display: 'none' }
                : null,
        };
    }, [rowData]);
    const unlinkHandler = useCallback((event, isOnZoneLevel, axis) => {
        // event handling here in case of unlink button clicked
        if (event) {
            event.stopPropagation();
        }
        onUnlink(rowData, isOnZoneLevel, rowData.tableMetaInfo.signalIndex, axis);
        if (axis === 'x') {
            if (isOnZoneLevel !== undefined) {
                if (isOnZoneLevel) {
                    assignmentZone.removeAll('x');
                }
                else {
                    assignmentSignal.removeAll('x');
                }
            }
        }
        else if (axis === 'y') {
            if (isOnZoneLevel !== undefined) {
                if (isOnZoneLevel) {
                    assignmentZone.removeAll('y');
                }
                else {
                    assignmentSignal.removeAll('y');
                }
            }
        }
        else {
            assignmentZone.removeAll('x');
            assignmentSignal.removeAll('x');
            assignmentZone.removeAll('y');
            assignmentSignal.removeAll('y');
        }
    }, [assignmentSignal, assignmentZone, onUnlink, rowData]);
    const clickHandler = useCallback((event, assignment, axis) => {
        event.stopPropagation();
        assignment.setActive(axis);
    }, []);
    const onHoverZoneX = useMemo(() => {
        return {
            onMouseEnter: () => {
                assignmentZone.show('x');
                highlightZoneX.show();
            },
            onMouseLeave: () => {
                assignmentZone.hide();
                highlightZoneX.hide();
            },
        };
    }, [assignmentZone, highlightZoneX]);
    const onHoverZoneY = useMemo(() => {
        return {
            onMouseEnter: () => {
                assignmentZone.show('y');
                highlightZoneY.show();
            },
            onMouseLeave: () => {
                assignmentZone.hide();
                highlightZoneY.hide();
            },
        };
    }, [assignmentZone, highlightZoneY]);
    const onHoverSignalX = useMemo(() => {
        return {
            onMouseEnter: () => {
                assignmentSignal.show('x');
                highlightSignalX.show();
            },
            onMouseLeave: () => {
                assignmentSignal.hide();
                highlightSignalX.hide();
            },
        };
    }, [assignmentSignal, highlightSignalX]);
    const onHoverSignalY = useMemo(() => {
        return {
            onMouseEnter: () => {
                assignmentSignal.show('y');
                highlightSignalY.show();
            },
            onMouseLeave: () => {
                assignmentSignal.hide();
                highlightSignalY.hide();
            },
        };
    }, [assignmentSignal, highlightSignalY]);
    return (_jsxs(DropdownMenu, { trigger: "contextMenu", options: contextMenu, onSelect: (selected) => onContextMenuSelect?.(selected, rowData), as: "tr", style: highlightZone.isActive || assignmentZone.isActive
            ? HighlightedRowStyle
            : lodashGet(rowData, 'tableMetaInfo.isConstantlyHighlighted', false)
                ? ConstantlyHighlightedRowStyle
                : null, ...highlightZone.onHover, children: [_jsx("td", { ...rowSpanTags, children: rowIndex + 1 }), _jsx(SignalDeltaColumn, { rowData: rowData, onHoverSignalX: onHoverSignalX, onHoverSignalY: onHoverSignalY, format: format }), _jsx(SignalAssignmentsColumns, { rowData: rowData, assignmentSignal: assignmentSignal, onHoverSignalX: onHoverSignalX, onHoverSignalY: onHoverSignalY, onClick: clickHandler, onUnlink: unlinkHandler, highlightSignalX: highlightSignalX, highlightSignalY: highlightSignalY }), _jsx(ZoneAssignmentsColumns, { rowData: rowData, assignmentZone: assignmentZone, onHoverZoneX: onHoverZoneX, onHoverZoneY: onHoverZoneY, rowSpanTags: rowSpanTags, onClick: clickHandler, onUnlink: unlinkHandler, highlightZoneX: highlightZoneX, highlightZoneY: highlightZoneY }), _jsx(ActionsColumn, { rowData: rowData, rowSpanTags: rowSpanTags })] }));
}
export default ZonesTableRow;
